export interface SupportedLocale {
  code: string;
  name: string;
  nativeName: string;
  region: string;
}

export interface SupportedCurrency {
  code: string;
  name: string;
  symbol: string;
}

export const SUPPORTED_LOCALES: SupportedLocale[] = [
  { code: "de", name: "German", nativeName: "Deutsch", region: "Deutschland" },
  { code: "en", name: "English", nativeName: "English", region: "United States" },
  { code: "en-GB", name: "English", nativeName: "English", region: "United Kingdom" },
  { code: "es", name: "Spanish", nativeName: "Español", region: "España" },
  { code: "fr", name: "French", nativeName: "Français", region: "France" },
  { code: "nl", name: "Dutch", nativeName: "Nederlands", region: "Nederland" },
  { code: "pt", name: "Portuguese", nativeName: "Português", region: "Portugal" },
];

export const SUPPORTED_CURRENCIES: SupportedCurrency[] = [
  { code: "USD", name: "United States Dollar", symbol: "$" },
  { code: "GBP", name: "British Pound", symbol: "\u00a3" },
  { code: "EUR", name: "Euro", symbol: "\u20ac" },
  { code: "CAD", name: "Canadian Dollar", symbol: "CA$" },
  { code: "AUD", name: "Australian Dollar", symbol: "A$" },
  { code: "NZD", name: "New Zealand Dollar", symbol: "NZ$" },
  { code: "JPY", name: "Japanese Yen", symbol: "\u00a5" },
  { code: "CHF", name: "Swiss Franc", symbol: "CHF" },
  { code: "SEK", name: "Swedish Krona", symbol: "kr" },
  { code: "NOK", name: "Norwegian Krone", symbol: "kr" },
  { code: "DKK", name: "Danish Krone", symbol: "kr" },
  { code: "SGD", name: "Singapore Dollar", symbol: "S$" },
  { code: "HKD", name: "Hong Kong Dollar", symbol: "HK$" },
  { code: "MXN", name: "Mexican Peso", symbol: "MX$" },
  { code: "BRL", name: "Brazilian Real", symbol: "R$" },
  { code: "ZAR", name: "South African Rand", symbol: "R" },
  { code: "CZK", name: "Czech Koruna", symbol: "Kč" },
  { code: "HUF", name: "Hungarian Forint", symbol: "Ft" },
  { code: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
  { code: "PLN", name: "Polish Zloty", symbol: "zł" },
  { code: "RON", name: "Romanian Leu", symbol: "lei" },
];

export function findLocale(code: string): SupportedLocale | undefined {
  return SUPPORTED_LOCALES.find((l) => l.code === code);
}

export function findCurrency(code: string): SupportedCurrency | undefined {
  return SUPPORTED_CURRENCIES.find((c) => c.code === code);
}

export function getLocaleLabel(code: string): string {
  const locale = findLocale(code);
  if (!locale) return code;
  if (locale.code.includes("-")) {
    const regionCode = locale.code.split("-")[1];
    return `${locale.nativeName} (${regionCode})`;
  }
  return locale.nativeName;
}

const ZERO_DECIMAL_CURRENCIES = new Set(["JPY", "HUF"]);

/** Returns 1 for zero-decimal currencies (JPY), 100 for standard currencies. */
export function subunitFactor(currency: string): number {
  return ZERO_DECIMAL_CURRENCIES.has(currency.toUpperCase()) ? 1 : 100;
}

export function getCurrencyLabel(code: string): string {
  const currency = findCurrency(code);
  if (!currency) return code;
  return `${currency.symbol} ${currency.code}`;
}
